module.exports = __webpack_public_path__ + "img/vd-kiss.698b8c8a.svg";